"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSocialIconSlots = exports.default = exports.SocialIcon = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _utils = require("../utils");
var _iconsMapping = require("./iconsMapping");
var _socialIconClasses = require("./socialIconClasses");
var _jsxRuntime = require("react/jsx-runtime");
var getSocialIconSlots = function(ownerState) {
    var size = ownerState.size, kind = ownerState.kind;
    return {
        root: [
            'root',
            "size".concat((0, _utils.capitalize)(size)),
            "kind".concat((0, _utils.capitalize)(kind))
        ],
        icon: [
            'icon'
        ]
    };
};
exports.getSocialIconSlots = getSocialIconSlots;
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = getSocialIconSlots(ownerState);
    var composedClasses = (0, _base.unstable_composeClasses)(slots, _socialIconClasses.getSocialIconUtilityClass, classes);
    return composedClasses;
};
var SocialIconRoot = (0, _material.styled)('span', {
    name: 'MuiOriSocialIcon',
    slot: 'Root',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.root,
            styles["size".concat((0, _utils.capitalize)(ownerState.size))],
            styles["kind".concat((0, _utils.capitalize)(ownerState.kind))]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread({
        display: 'inline-block',
        position: 'relative',
        boxSizing: 'border-box',
        overflow: 'hidden',
        borderRadius: '50%',
        margin: theme.spacing(1),
        padding: 0,
        textAlign: 'center',
        verticalAlign: 'middle',
        cursor: 'pointer',
        textDecoration: 'none',
        fontWeight: 'normal',
        '&::after': {
            content: '" "',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: theme.palette.common.black,
            opacity: 0
        },
        '&:hover, &:focus': {
            color: theme.palette.common.white,
            fontWeight: 'normal'
        },
        '&:hover&::after, &:focus&::after': {
            opacity: 0.4
        }
    }, ownerState.size === 'medium' && {
        width: '3.5rem',
        height: '3.5rem',
        fontSize: '3.3rem',
        lineHeight: '4.2rem'
    }, ownerState.size === 'small' && {
        width: '3rem',
        height: '3rem',
        fontSize: '2.8rem',
        lineHeight: '3.6rem'
    }, ownerState.kind === 'email' && {
        color: '#333',
        '&:hover, &:focus': {
            color: '#333',
            fontWeight: 'normal'
        }
    }, ownerState.kind === 'messenger' && {
        borderRadius: '50% 50% 50% 20%',
        background: 'radial-gradient(#fff 0%, #fff 62%, transparent 63%)',
        '&:hover, &:focus': {
            fontWeight: 'normal'
        }
    }, ownerState.kind === 'vkontakte' && {
        borderRadius: '25%',
        background: 'radial-gradient(#fff 0, #fff 65%, transparent 70%)'
    }, ownerState.kind === 'wechat' && _object_spread({
        borderRadius: '20%',
        fontSize: '4.4rem'
    }, ownerState.size === 'small' && {
        fontSize: '3.7rem'
    }));
});
var IconRoot = (0, _material.styled)(_material.SvgIcon, {
    name: 'MuiOriSocialIcon',
    slot: 'Icon',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.icon
        ];
    }
})(function(param) {
    var ownerState = param.ownerState;
    return _object_spread({}, ownerState.size === 'medium' && {
        fontSize: '5.1rem',
        transform: 'translate(-0.8rem, -0.8rem)'
    }, ownerState.size === 'small' && {
        fontSize: '4.4rem',
        transform: 'translate(-0.7rem, -0.7rem)'
    }, ownerState.kind === 'messenger' && ownerState.size === 'small' && {
        fontSize: '4.36rem',
        transform: 'translate(-0.66rem, -0.68rem)'
    });
});
var SocialIcon = exports.SocialIcon = /*#__PURE__*/ (0, _react.forwardRef)(function(inProps, ref) {
    var props = (0, _material.useThemeProps)({
        props: inProps,
        name: 'MuiOriSocialIcon'
    });
    var kind = props.kind, className = props.className, _props_size = props.size, size = _props_size === void 0 ? 'medium' : _props_size, _props_component = props.component, component = _props_component === void 0 ? 'span' : _props_component, other = _object_without_properties(props, [
        "kind",
        "className",
        "size",
        "component"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        size: size,
        kind: kind
    });
    var classes = useUtilityClasses(ownerState);
    var icon = _iconsMapping.iconsMapping[ownerState.kind].icon;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SocialIconRoot, _object_spread_props(_object_spread({
        ref: ref,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        as: component,
        "aria-label": component === _material.ButtonBase || component === 'button' ? ownerState.kind : undefined,
        tabIndex: component === 'button' ? 0 : undefined,
        title: component === _material.Link || component === 'a' ? ownerState.kind : undefined
    }, other), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconRoot, {
            as: icon,
            ownerState: ownerState,
            fontSize: "inherit",
            className: classes.icon
        })
    }));
});
var _default = exports.default = SocialIcon; //# sourceMappingURL=SocialIcon.js.map
